package app.nestbridge.feature.common.ui

import app.nestbridge.feature.common.screen.DocumentViewerScreen
import app.nestbridge.feature.common.screen.DocumentViewerState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class DocumentUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is DocumentViewerScreen -> ui<DocumentViewerState> { state, modifier -> DocumentUi(state = state, modifier = modifier) }
    else -> null
  }
}
